<section>
  <h3>View on</h3>
  <mat-button-toggle-group #group="matButtonToggleGroup" [value]="tab">
    <mat-button-toggle [value]="breakpoint" (change)="onChangeToggle($event, group)" *ngFor="let breakpoint of breakpoints">{{ breakpoint | titlecase }}</mat-button-toggle>
  </mat-button-toggle-group>
  <div class="hint-box">
    <mat-icon class="hint-icon">info</mat-icon>
    <span class="hint-text">Publish to view the latest changes.</span>
  </div>
</section>
